"use client";

import { useRouter } from "next/navigation";
import { LOCALE_COOKIE, type Locale } from "./config";
import { useI18n } from "./I18nProvider";

const ONE_YEAR = 60 * 60 * 24 * 365;

export function LanguageSwitcher() {
  const router = useRouter();
  const { locale } = useI18n();

  function setLocale(nextLocale: Locale) {
    if (nextLocale === locale) return;

    document.cookie = [
      `${LOCALE_COOKIE}=${nextLocale}`,
      "Path=/",
      `Max-Age=${ONE_YEAR}`,
      "SameSite=Lax",
    ].join("; ");

    document.documentElement.lang = nextLocale;
    router.refresh();
  }

  return (
    <div
      aria-label="Language"
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: 3,
        borderRadius: 999,
        border: "1px solid rgba(255,255,255,.14)",
        background: "rgba(255,255,255,.035)",
      }}
    >
      {(["es", "en"] as const).map((item) => {
        const active = item === locale;

        return (
          <button
            key={item}
            type="button"
            onClick={() => setLocale(item)}
            aria-pressed={active}
            style={{
              border: 0,
              borderRadius: 999,
              padding: "7px 9px",
              cursor: "pointer",
              background: active ? "#feb501" : "transparent",
              color: active ? "#111827" : "#aeb7c3",
              fontSize: 11,
              fontWeight: 800,
              letterSpacing: ".08em",
            }}
          >
            {item.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
